module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAApUlEQVR4AWOgLrCYvA6IpSkx4D8QfwDiTLINmKgQ9V/ItAdk0GEgVifZgDsiNv9vxdb8nxXYBDLkJxDXATEb0Qa8613wHwZOT1r331+7BGTQVSC2JNYFIEPA+Hl0+f9T4s7/JytE/oeGz2Qg5iFkABjnqmVANGHiJ0AciM8AdEPqSA1EkNNBmHRDgArBGqEAwxByDUAxhFQvEAoTTAOIxHUMgwYAADsex9mwXM2qAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NP.png
// module id = 1231
// module chunks = 0